<template>
  <div class="batch-card-body">
    <p class="batch-card-body__title">
      <span
        :class="{
          'open': stateName === 'Aberto',
          'closed': stateName === 'Completo'
        }"
      >
        {{ totalSamples }}
      </span>
    </p>

    <p class="batch-card-body__subtitle">
      AMOSTRA<span v-if="totalSamples > 1">S</span>
    </p>

    <hr>

    <div class="batch-card-body__description">
      <span
        :class="{
          'open': stateName === 'Aberto',
          'closed': stateName === 'Completo'
        }"
      >
        {{ stateName }}
      </span>
    </div>
  </div>
</template>

<script>
import strings from '@/strings'

export default {
  name: 'BatchCardBody',
  props: {
    totalSamples: {
      type: Number,
      default: 0
    },
    batchState: {
      type: String
    }
  },
  computed: {
    stateName() {
      return strings.batchStates[this.batchState].translatedState
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-card-body {
  &__title {
    font-weight: 800;
    letter-spacing: -0.3px;
    line-height: 28px;
    padding-top: 1px;
    font-size: 32px;
  }

  &__subtitle {
    letter-spacing: 1.62px;
    padding-top: 5px;
    font-size: 13px;
  }

  &__description {
    font-size: 12px;
    font-weight: 700;
  }

  .closed {
    color: #219653;
    opacity: 0.93;
  }

  .open {
    color: #f2c94c;
    opacity: 0.93;
  }
}
</style>
